export default __webpack_public_path__ + "static/media/3-cn.d30c6b8b.webp";